import {identity} from 'lodash';

export default function resolvePath(...args) {
    // console.log('RESOLVE PATH >>> ', args);

    // remove stuff before first slash
    let start = args.findIndex(str => str.toString().match(/^\//));
    if (start !== -1) args.splice(0, start);

    // split on slash
    args = args.flatMap(str => str.toString().split('/'));

    // trim elements and remove empty parts
    args = args.map(str => str.toString().trim()).filter(identity);

    // ignore .
    args = args.filter(str => str != '.');

    // jump to parent on ..
    while (args.find(str => str == '..')) {
        let position = args.findIndex(str => str == '..');
        args.splice(position - 1, 2);
    }

    return '/' + args.join('/');
}
